<template>
  <div class="row mt-3">
    <div class="col-md-4 px-2 d-none d-md-block">
      <div class="card">
        <div class="card-body">
          <current-user :user="current_user" />
        </div>
      </div>
    </div>
    <div class="col-md-8 px-2">
      <div class="card mb-3" v-if="current_user">
        <div class="card-body">
          <mags-new :current-user="current_user" @add-mag="newMag = $event" />
        </div>
      </div>
      <div class="card mb-3" v-else>
        <div class="card-body">
          <pr :show-timeline-button="false" />
        </div>
      </div>
      <div class="card mb-3 d-md-none" v-if="current_user">
        <div class="card-body">
          <chart :mags="current_user.mags_for_stats" :is-profile-page="false" />
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <timeline :current-user="current_user" :target-user-ids="null" :new-mag="newMag" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MagsNew from './_new'
import CurrentUser from '../users/_current_user'
import Timeline from './_timeline'
import Pr from '../users/_pr'
import Chart from '../charts/_show'

export default {
  components: { MagsNew, CurrentUser, Timeline, Pr, Chart },
  props: ['current_user'],
  data() { return { newMag: null } },
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
